import React, { useState } from 'react'
import Experience from './Experience'

const AIWorkshop = () => {

  const [showFilters, setshowFilters] = useState(true);
  const toggleFilters = () => {
    setshowFilters(!showFilters);
};

  return (
    <div>
      <Experience isVisible={showFilters} toggleFilters={toggleFilters}/>
    </div>
  )
}

export default AIWorkshop;
